<template>
  <div class="modal fade" id="upload-evidence-image-modal" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog modal-md" @click.stop>
      <div class="modal-content">
        <div class="modal-body">
          <div class="flexbox">
            <div class="col-sm-12">
              <evidence-image-input
                @close="$emit('close')"
                @handleSuccess="$emit('handleSuccess')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EvidenceImageInput from '@/components/EvidenceImageInput'
export default {
  components: {
    EvidenceImageInput
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>
<style scoped>
#upload-evidence-image-modal {
  z-index: 1049;
}
#upload-evidence-image-modal /deep/ .dz-error-message {
  top: 40%;
  padding: 0.2rem 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAmazon/UploadEvidenceImageModal.vue